import React from 'react';
import UserInfo from '../UserInfo/UserInfo';
import { useTranslation } from 'react-i18next';
import ResponsiveModal from '../../Shared/ResponsiveModal/ResponsiveModal';
import useMobileFullscreenModalBackHandler from '../../../Hooks/useMobileFullscreenModalBackHandler';

const UserViewModal = ({
    modalVisible,
    handleCancel,
    user,
    screens,
    onDeleteProfilePicture
}) => {
    const { t } = useTranslation();

    // Close fullscreen user view modal with mobile system back
    useMobileFullscreenModalBackHandler(!!modalVisible && screens?.xs, handleCancel);

    return (
        <ResponsiveModal
            key={modalVisible}
            title={t('user_information')}
            open={modalVisible}
            onCancel={handleCancel}
            destroyOnClose
            desktopWidth={820}
            footer={null}
        >
            <UserInfo user={user} onDeleteProfilePicture={onDeleteProfilePicture} />
        </ResponsiveModal>
    );
};

export default UserViewModal;
